import {
  type AccountStateQuery,
  FundingQuery,
  IndexPriceQuery,
  InterestRateQuery,
  IVQuery,
  OBInstrumentQuery,
  OBMakerQuery,
  OBOptionQuery,
  type OBPerpQuery,
  type PositionQuery,
  RFQQuery,
  TradeQuery,
} from "./subscriptionQueries";

/**
 * 👷‍♂️ => 🌐 Channel types for subscriptions from the worker to the server.
 */
export enum ChannelType {
  AccountLiquidation = "account_liquidation",
  AccountState = "account_state",
  Bankruptcy = "bankruptcy",
  Funding = "funding",
  IndexPrice = "index_price",
  Instruments = "instruments",
  InterestRate = "interest_rate",
  IV = "iv",
  MMP = "mmp",
  OrderbookMaker = "orderbook_maker",
  OrderbookOptions = "orderbook_options",
  OrderbookPerps = "orderbook_perps",
  Position = "position",
  RFQ = "rfq",
  Trade = "trade",
  Transfer = "transfer",
}

export interface FundingSubscription {
  channel: ChannelType.Funding;
  query: FundingQuery;
}

export interface IndexPriceSubscription {
  channel: ChannelType.IndexPrice;
  query: IndexPriceQuery;
}

export interface OBInstrumentSubscription {
  channel: ChannelType.OrderbookOptions | ChannelType.OrderbookPerps;
  query: OBInstrumentQuery;
}
export interface OBOptionSubscription {
  channel: ChannelType.OrderbookOptions;
  query: OBOptionQuery;
}

export interface OBPerpSubscription {
  channel: ChannelType.OrderbookPerps;
  query: OBPerpQuery;
}

export interface TradeSubscription {
  channel: ChannelType.Trade;
  query: TradeQuery;
}

export interface AccountStateSubscription {
  channel: ChannelType.AccountState;
  query: AccountStateQuery;
}

export interface PositionSubscription {
  channel: ChannelType.Position;
  query: PositionQuery;
}

export interface InterestRateSubscription {
  channel: ChannelType.InterestRate;
  query: InterestRateQuery;
}

export interface IVSubscription {
  channel: ChannelType.IV;
  query: IVQuery;
}

export interface OBMakerSubscription {
  channel: ChannelType.OrderbookMaker;
  query: OBMakerQuery;
}

export interface RFQSubscription {
  channel: ChannelType.RFQ;
  query: RFQQuery;
}

export type Subscription =
  | FundingSubscription
  | IndexPriceSubscription
  | OBInstrumentSubscription
  | OBOptionSubscription
  | OBPerpSubscription
  | TradeSubscription
  | AccountStateSubscription
  | PositionSubscription
  | InterestRateSubscription
  | IVSubscription
  | OBMakerSubscription
  | RFQSubscription;
